import { render, staticRenderFns } from "./small-business.vue?vue&type=template&id=72989d8f&scoped=true&"
import script from "./small-business.vue?vue&type=script&lang=js&"
export * from "./small-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72989d8f",
  null
  
)

export default component.exports